module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-07.8c1c1801.png";